"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterface = void 0;
var react_1 = require("react");
/** Shorthand for implementing interface methods in a forwardRef functional component  */
var useInterface = function (ref, object) {
    (0, react_1.useImperativeHandle)(ref, function () { return object; });
};
exports.useInterface = useInterface;
